module.exports = __webpack_public_path__ + "img/JSP.5812c873.svg";